<template>
  <el-row type="flex" justify="space-between" align="middle">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/leisure' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item v-if="pre"><a @click="$router.back()">{{ pre }}</a></el-breadcrumb-item>
      <el-breadcrumb-item>{{ curr }}</el-breadcrumb-item>
    </el-breadcrumb>
    <el-button @click="$router.back()" type="primary" round size="mini" plain icon="el-icon-back">后退</el-button>
  </el-row>
</template>
<script>
export default {
    props: {
        curr: String,
        pre: String
    }
}
</script>
